export const subscribers = state => state.subscribers.items
export const subscribersByReference = state =>
    (reference_type, reference_id) => {
        reference_id = parseInt(reference_id)
        return _.map(_.filter(subscribers(state), {reference_type, reference_id}), 'user_id')
    }
